const getUserSettings = () => {
  const userSettings = window.App.userSettings || {}
  return {
    presetPrices: userSettings.preset_prices,
    presetPlayersNumbers: userSettings.preset_players_numbers || [8, 9, 10, 11, 12, 13, 14],
    buttonsPosition: userSettings.shop_reservation_buttons_position || 0,
  }
}

const initialState = {
  ...getUserSettings(),
  isActive: false,
  currentPrice: null,
  priceMultiplier: 1,
  reservationId: null,
  playerId: null,
  playerFirstName: null,
  playerLastName: null,
  playerPhoneNumber: null,
  playerCountryCode: 'US',
  taxPercent: 0,
  reservationIdGroups: []
}

const storeReceivedData = (state, payload) => ({
  ...state,
  taxPercent: payload.tax_percent,
  reservationIdGroups: payload.reservation_id_groups
})

const addNewPrice = (state, price) => {
  if (!price) return state
  const presetPrices = state.presetPrices.includes(price) ?
    state.presetPrices : [...state.presetPrices.slice(0, 6), price]
  return { ...state, currentPrice: price, presetPrices, priceMultiplier: 1, currentPlayersNumber: null }
}

const calculatePriceMultiplier = (priceMultiplier, clickPosition, isNewNumber) => {
  if (isNewNumber) return 1
  if (clickPosition === "right") return priceMultiplier + 1
  return priceMultiplier > 1 ? priceMultiplier - 1 : 1
}

const addNewPlayersNumber = (state, {value, clickPosition}) => {
  if (!value) return state
  const presetPlayersNumbers = state.presetPlayersNumbers.includes(value) ?
    state.presetPlayersNumbers : [...state.presetPlayersNumbers.slice(0, 6), value]
  let priceMultiplier =
    calculatePriceMultiplier(state.priceMultiplier, clickPosition, state.currentPlayersNumber !== value)
  return { ...state, currentPlayersNumber: value, priceMultiplier, presetPlayersNumbers }
}

const setPlayer = (state, payload) => {
  const newState = {...state}
  if (typeof(payload.id) !== "undefined" ) newState.playerId = payload.id;
  if (typeof(payload.firstName) !== "undefined" ) newState.playerFirstName = payload.firstName;
  if (typeof(payload.lastName) !== "undefined" ) newState.playerLastName = payload.lastName;
  if (typeof(payload.phoneNumber) !== "undefined" ) newState.playerPhoneNumber = payload.phoneNumber;
  if (typeof(payload.countryCode) !== "undefined" ) newState.playerCountryCode = payload.countryCode;
  if (typeof(payload.email) !== "undefined" ) newState.playerEmail = payload.email;
  return newState
}

const cancelReservation = state => ({
  ...state,
  isActive: false,
  reservationId: null,
  playerFirstName: null,
  playerLastName: null,
  playerId: null,
  playerPhoneNumber: null
})

const addReservation = state => {
  if (!state.reservationId || !state.currentPrice) return cancelReservation(state)
  return {...state, isActive: false}
}

const reservation = (state = initialState, {type, payload}) => {
  switch (type) {
    case "SHOP.INIT":
      return {...initialState, ...getUserSettings()}
    case "SHOP_RESERVATION_ADD":
      return {...state, isActive: true}
    case "SHOP_RESERVATION_ADDED":
      return addReservation(state)
    case "SHOP_RESERVATION_CANCEL":
      return cancelReservation(state)
    case "SHOP_RESERVATION_PRICE_CHANGED":
      return payload.skipPreset ? {...state, currentPrice: payload.value} : addNewPrice(state, payload.value)
    case "CHANGE_SHOP_RESERVATION_PLAYERS_NUMBER":
      return addNewPlayersNumber(state, payload)
    case "SHOP_RESERVATIONS_RECEIVED":
      return storeReceivedData(state, payload)
    case "SHOP_RESERVATION_SELECTED":
      return {...state, reservationId: payload.id}
    case "SHOP_RESERVATION_PLAYER_CHANGED":
      return setPlayer(state, payload)
    case "CHANGE_SHOP_RESERVATION_BUTTONS_POSITION":
      return {...state, buttonsPosition: payload.value}
    case "PAYMENT_SUCCESS":
      return {...state, priceMultiplier: 1}
    default:
      return state
  }
}

export default reservation;
